export type ApiError = Error & { code?: string };

/** Preserve the backend's stable error code on the thrown Error. */
export function createApiError(message: string, code?: unknown): ApiError {
  const error = new Error(message) as ApiError;
  if (typeof code === 'string' && code) {
    error.code = code;
  }
  return error;
}
